import { render, staticRenderFns } from "./CounselorBySpecialtyPercentage.vue?vue&type=template&id=6bcadb86&"
import script from "./CounselorBySpecialtyPercentage.vue?vue&type=script&lang=js&"
export * from "./CounselorBySpecialtyPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports